import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, SubscriptionStatus } from '../types';
import apiClient from '../services/apiClient';
import { setSubscription } from '../redux/actions';

export const useSubscription = () => {
	const dispatch = useDispatch();
	const user = useSelector((state: RootState) => state.auth.user);
	const subscription = useSelector((state: RootState) => state.auth.subscription);
	const [subscriptionStatus, setSubscriptionStatus] = useState<SubscriptionStatus | null>(null);

	useEffect(() => {
		// Only fetch subscription if we have a shop selected
		if (user?.shop_hash_id) {
			fetchSubscription();
		}
	}, [user?.shop_hash_id]);

	const fetchSubscription = async () => {
		try {
			const response = await apiClient.get('/subscriptions/current');
			const data = response.data;

			// Set subscription data
			dispatch(setSubscription(data.subscription));

			// Set subscription status
			setSubscriptionStatus(data.subscriptionStatus);
		} catch (error) {
			console.error('Failed to fetch subscription:', error);
			// Set null to indicate no subscription
			dispatch(setSubscription(null));
			setSubscriptionStatus(null);
		}
	};

	return {
		subscription,
		subscriptionStatus,
		isSubscriptionActive: subscriptionStatus?.effectiveStatus === 'active_subscription',
		isTrialing: subscriptionStatus?.effectiveStatus === 'trial',
		isInGracePeriod: subscriptionStatus?.effectiveStatus === 'grace_period',
		isExpired: subscriptionStatus?.effectiveStatus === 'expired',
		refetchSubscription: fetchSubscription,
	};
};
